export default "__VITE_ASSET__ad7df504__"